<div class="min-h-96 p-5 m-auto flex justify-center items-center">
  <form [formGroup]="form" class="flex flex-col w-full">
    <!-- title -->
    <h1 class="mb-2" *ngIf="showTitle">
      {{ 'financialToolStudentPayment:heading' | translate }}
    </h1>

    <!-- select currency and amount together -->
    <div class="flex flex-col" *ngIf="tab == 'collect'">
      <div class="font-medium label mb-1">{{ labelOne }} *</div>
      <mat-form-field>
        <input
          matInput
          formControlName="paymentAmount"
          (input)="fc['paymentAmount'].markAsTouched()"
          number="1.1-2"
          required />
        <mat-select
          formControlName="sourceCurrency"
          matPrefix
          required
          placeholder="Currency">
          <mat-select-trigger>
            <div class="flex items-center mr-2" *ngIf="fv.sourceCurrency">
              <img
                class="object-cover w-6 h-6 rounded-full mr-2"
                src="https://flagcdn.com/{{
                  fv.sourceCurrency | currencyCountry
                }}.svg"
                [alt]="fv.sourceCurrency"
                width="36"
                height="27" />
              <span *ngIf="fv.sourceCurrency">{{ fv.sourceCurrency }}</span>
            </div>
          </mat-select-trigger>
          <mat-option *ngFor="let code of currencies" [value]="code">
            <div class="flex items-center justify-start">
              <img
                class="object-cover w-6 h-6 rounded-full mr-2"
                src="https://flagcdn.com/{{ code | currencyCountry }}.svg"
                [alt]="code"
                width="36"
                height="27" />
              <span>{{ code }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- select currency and amount separated -->
    <div class="flex flex-col" *ngIf="tab != 'collect'">
      <mat-form-field>
        <mat-label>Select the currency account</mat-label>
        <mat-select
          class="py-3"
          formControlName="sourceCurrency"
          required
          placeholder="Currency">
          <mat-select-trigger>
            <div class="flex items-center" *ngIf="fv.sourceCurrency">
              <img
                class="object-cover w-6 h-6 rounded-full mr-2"
                src="https://flagcdn.com/{{
                  fv.sourceCurrency | currencyCountry
                }}.svg"
                [alt]="fv.sourceCurrency"
                width="36"
                height="27" />
              <span *ngIf="fv.sourceCurrency">{{ fv.sourceCurrency }}</span>
            </div>
          </mat-select-trigger>
          <mat-option *ngFor="let code of currencies" [value]="code">
            <div class="flex items-center justify-start">
              <img
                class="object-cover w-6 h-6 rounded-full mr-2"
                src="https://flagcdn.com/{{ code | currencyCountry }}.svg"
                [alt]="code"
                width="36"
                height="27" />
              <span>{{ code }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Insert the amount to send</mat-label>
        <div class="flex items-center">
          <img
            class="object-cover w-6 h-6 rounded-full mr-2"
            src="https://flagcdn.com/{{
              fv.sourceCurrency | currencyCountry
            }}.svg"
            [alt]="fv.sourceCurrency"
            width="36"
            height="27" />
          <span>{{ fv.sourceCurrency }}</span>
        </div>
        <input
          matInput
          formControlName="paymentAmount"
          number="1.1-2"
          required />
      </mat-form-field>
    </div>

    <!-- price information -->
    <div class="flex flex-col p-5 gap-2" *ngIf="fv.paymentMethod?.taxes">
      <div
        class="flex justify-between"
        *ngFor="let item of fv.paymentMethod?.taxes">
        <div class="flex gap-2">
          <i class="fa-regular fa-credit-card text-gray-400"></i>
          <div class="">{{ item.name }}</div>
        </div>
        <div class="font-medium">
          {{
            item.amount
              | currency
                : fv.paymentMethod?.convertedCurrency
                : 'symbol-narrow'
                : '1.2-2'
          }}
          {{ fv.paymentMethod?.convertedCurrency }}
        </div>
      </div>
    </div>

    <!-- beneficiary account -->
    <mat-form-field *ngIf="tab != 'collect'">
      <mat-label>Select the beneficiary account</mat-label>
      <mat-select
        class="py-3"
        formControlName="currencyPayFrom"
        required
        placeholder="Currency">
        <mat-select-trigger>
          <div class="flex items-center" *ngIf="fv.currencyPayFrom">
            <img
              class="object-cover w-6 h-6 rounded-full mr-2"
              src="https://flagcdn.com/{{
                fv.currencyPayFrom | currencyCountry
              }}.svg"
              [alt]="fv.currencyPayFrom"
              width="36"
              height="27" />
            <span *ngIf="fv.currencyPayFrom">{{ fv.currencyPayFrom }}</span>
          </div>
        </mat-select-trigger>
        <mat-option
          *ngFor="
            let code of tab == 'send' ? currencies : currenciesIsWithdrawable
          "
          [value]="code">
          <div class="flex items-center justify-start">
            <img
              class="object-cover w-6 h-6 rounded-full mr-2"
              src="https://flagcdn.com/{{ code | currencyCountry }}.svg"
              [alt]="code"
              width="36"
              height="27" />
            <span>{{ code }}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- countryPayFrom -->
    <mat-form-field *ngIf="tab == 'collect'">
      <mat-label>{{ 'The student is paying from:' }}</mat-label>
      <mat-select
        class="py-4"
        formControlName="countryPayFrom"
        required
        placeholder="">
        <mat-select-trigger>
          <div class="flex items-center" *ngIf="fv.countryPayFrom">
            <img
              class="object-cover w-6 h-6 rounded-full mr-2"
              src="https://flagcdn.com/{{ fv.countryPayFrom.iso }}.svg"
              [alt]="fv.countryPayFrom.name"
              width="36"
              height="27" />
            <span>{{ fv.countryPayFrom.name }}</span>
          </div>
        </mat-select-trigger>
        <mat-option *ngFor="let country of countries" [value]="country">
          <div class="flex items-center justify-start">
            <img
              class="object-cover w-6 h-6 rounded-full mr-2"
              src="https://flagcdn.com/{{ country.iso }}.svg"
              [alt]="country.name"
              width="36"
              height="27" />
            <span>{{ country.name }}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- paymentMethod -->
    <mat-form-field *ngIf="tab == 'collect'">
      <mat-label>{{ 'Select type of payment' }}</mat-label>
      <mat-select
        class="py-4"
        formControlName="paymentMethod"
        required
        placeholder="">
        <mat-select-trigger>
          <div class="flex items-center" *ngIf="fv.paymentMethod">
            <img
              class="w-6 h-6 mr-2"
              [src]="fv.paymentMethod.logo"
              [alt]="fv.paymentMethod.type"
              width="36"
              height="27" />
            <span>{{ fv.paymentMethod.type }}</span>
          </div>
        </mat-select-trigger>
        <mat-option *ngFor="let item of paymentMethods" [value]="item">
          <div class="flex items-center justify-start">
            <img
              class="w-6 h-6 mr-2"
              [src]="item.logo"
              [alt]="item.type"
              width="36"
              height="27" />
            <span>{{ item.type }}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-template [ngIf]="fv.paymentMethod?.lockReason">
      <treo-message
        [appearance]="'outline'"
        [showIcon]="true"
        [showButtonClose]="false"
        [type]="'info'">
        <div>
          {{ fv.paymentMethod?.lockReason }}
        </div>
      </treo-message>
    </ng-template>

    <ng-template [ngIf]="!fv.paymentMethod?.lockReason">
      <!-- paymentMethodSelect -->
      <div class="font-medium label mb-1">{{ labelPaymentMethodSelect }}</div>
      <div
        class="flex justify-between border border-gray-300 rounded-md shadow-sm py-2 px-4 min-h-12">
        <div class="contents" *ngIf="!loading && fv.paymentMethod">
          <div class="flex items-center">
            <img
              class="object-cover w-6 h-6 rounded-full mr-2"
              src="https://flagcdn.com/{{
                fv.paymentMethod?.convertedCurrency | currencyCountry
              }}.svg"
              [alt]="fv.paymentMethod?.convertedCurrency"
              width="36"
              height="27" />
            <span>{{ fv.paymentMethod?.convertedCurrency }}</span>
          </div>
          <div class="font-medium tracking-tighter text-3xl">
            <span>{{
              fv.paymentMethod?.convertedAmount
                | currency
                  : fv.paymentMethod?.convertedCurrency
                  : 'symbol-narrow'
                  : '1.2-2'
            }}</span>
          </div>
        </div>
        <mat-spinner
          class="ml-auto"
          diameter="35"
          *ngIf="loading"></mat-spinner>
      </div>

      <!-- price information -->
      <div class="flex flex-col p-4 py-2 gap-2">
        <div class="flex justify-between">
          <div class="flex gap-2">
            <img src="assets/icon2.svg" [style.width.px]="20" alt="" />
            <div
              *ngIf="fv.sourceCurrency != fv.paymentMethod?.convertedCurrency">
              1 {{ fv.sourceCurrency }} =
              {{
                (tab == 'collect'
                  ? fv.paymentMethod?.convertedAmount /
                    fv.paymentMethod?.sourceAmount
                  : fv.paymentMethod?.fxRate
                ) | number : '.2-2'
              }}
              {{ fv.paymentMethod?.convertedCurrency }}
            </div>
            <div
              *ngIf="fv.sourceCurrency == fv.paymentMethod?.convertedCurrency">
              1 {{ fv.sourceCurrency }} = 1
              {{ fv.paymentMethod?.convertedCurrency }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </form>
</div>
